import { Object } from "core-js";

export default Object.freeze({
    MissedDelivery: 'MissedDelivery',
    Confirmation: 'Confirmation',
    PreDeliveryRedirection: 'PreDeliveryRedirection',
    PageNotFound: 'NotFound'
});